'use strict'

import { Fill, Stroke, Style, Circle } from 'ol/style'
import { Vector as VectorSource } from 'ol/source'
import { Vector as VectorLayer } from 'ol/layer'
import GeoJSON from '@/utils/geoJson'
import { get as getProjection } from 'ol/proj'

import Config from '@/config.js'
import { Feature } from 'ol'

// NOTE
// Les states avec un _ doivent être accédés via des getters
// Les mutations avec un _ doivent être appelées uniquement depuis des actions

export default {
  state: {
    mapLoading: true,
    mapRef: {},           // Référence vers l'objet OpenLayers
    backgroundLayer: {    // Fond de carte du viewer
      name: Config.mapConfiguration.defaultBackgroundLayer,
      opacity: 1
    },
    topographyLayer: {},         // Topographie
    mapLegend: null,
    currentGeom: null,
    currentObject: {},           // L'objet contenant les données de currentGeom. Est chargé par un outil,
    hoverLayer: null,
    defaultHoverStyle: new Style({
      stroke: new Stroke({
        color: '#60b0f5',
        width: 1
      }),
      image: new Circle({
        radius: 6,
        fill: new Fill({
          color: '#60b0f5'
        }),
        stroke: new Stroke({
          color: 'white'
        }),
      })
    })
  },
  getters: {
    mapView (state) {
      return state.mapRef.getView()
    }
  },
  mutations: {
    _setLoadingState (state, loading) {
      state.mapLoading = loading
    },
    _setMapRef (state, mapRef) {
      state.mapRef = mapRef
    },
    setTopographyLayer (state, topographyLayer) {
      state.topographyLayer = topographyLayer
    },
    setMapLegend (state, mapLegend) {
      state.mapLegend = mapLegend
    },
    setCurrentGeom (state, geom) {
      state.currentGeom = geom
    },
    setCurrentObject (state, object) {
      state.currentObject = object
    },
    setBackgroundLayerName (state, name) {
      state.backgroundLayer.name = name
    },
    setBackgroundLayerOpacity (state, opacity) {
      state.backgroundLayer.opacity = opacity
    },
    setHoverGeoJSON (state, feature) {
      let toHover = GeoJSON.readFeature(feature, {
        dataProjection: getProjection(Config.mapConfiguration.projection),
        featureProjection: getProjection(Config.mapConfiguration.projection)
      })
      state.hoverLayer.getSource().clear()
      state.hoverLayer.getSource().addFeature(toHover)
    },
    setHoverStyle (state, style) {
      state.hoverLayer.setStyle(style)
    },
    setDefaultHoverStyle (state) {
      state.hoverLayer.setStyle(state.defaultHoverStyle)
    },
    setHoverGeom (state, geom) {
      let toHover = new Feature(geom)
      state.hoverLayer.getSource().clear()
      state.hoverLayer.getSource().addFeature(toHover)
    },
    clearHoverFeature (state) {
      state.hoverLayer.getSource().clear()
    },
    addHoverFeature (state, feature) {
      state.hoverLayer.getSource().addFeature(feature)
    },
    removeHoverFeature (state, feature) {
      state.hoverLayer.getSource().removeFeature(feature)
    },
    _initHoverLayer (state) {
      let hoverSource = new VectorSource({
        features: []
      })

      state.hoverLayer = new VectorLayer({
        source: hoverSource,
        style: state.defaultHoverStyle,
        zIndex: 100
      })

      state.mapRef.addLayer(state.hoverLayer)
    },
  },
  actions: {
    initMap ({ commit }, mapRef) {
      commit('_setLoadingState', true)
      commit('_setMapRef', mapRef)
      commit('_setLoadingState', false)
      commit('_initHoverLayer')
    },
  }
}
